<template>
    <div class="content">
        <div class="row" v-for="(item,index) in datas" :key="index">
            <router-link target ="_blank" v-bind:to="url" @click="click(item)">{{item.name}}</router-link>
        </div>
    </div>
   
</template>

<script>
export default {
    props:{
        datas:Array
    },
    data(){
        return{
            url :''
        }
    },
    methods:{
        click(item){
            this.url = item.url+'?id='+item.id;
            console.log( this.url);
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    width: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;

    .row{
        height: 36px;
        padding: 0 10px;
        margin: 0 10px;
        text-align: left;
        line-height: 36px;
        border-bottom: 1px #cecece dashed;

        a{
            font-size: 1.6ch;
            color: #222;
            text-decoration: none;
        }
    }

    .row:hover{
        a{
            color: #045978;
        }
    }
}
</style>
